import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMegaphone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 2.75C13.5 2.33579 13.1642 2 12.75 2C12.3358 2 12 2.33579 12 2.75V4.75C12 5.16421 12.3358 5.5 12.75 5.5C13.1642 5.5 13.5 5.16421 13.5 4.75V2.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.4403 4.55967C19.7332 4.85256 19.7332 5.32743 19.4403 5.62033L17.7303 7.33033C17.4374 7.62323 16.9626 7.62323 16.6697 7.33033C16.3768 7.03744 16.3768 6.56257 16.6697 6.26967L18.3797 4.55967C18.6726 4.26677 19.1475 4.26677 19.4403 4.55967Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.6503 6.11967C10.3574 5.82677 9.88256 5.82677 9.58967 6.11966C9.29677 6.41256 9.29677 6.88743 9.58966 7.18032L9.82256 7.41322L4.29676 14.2485C4.29155 14.2549 4.28646 14.2615 4.28149 14.268C3.83087 14.7209 3.42347 15.1515 3.1011 15.5701C2.76081 16.012 2.48006 16.4844 2.35424 17.0055C2.07956 18.143 2.60795 19.1586 3.64966 20.2003C4.69114 21.2418 5.70602 21.7719 6.84353 21.4974C7.36454 21.3717 7.83692 21.0908 8.2788 20.7503C8.55026 20.5411 8.82691 20.2961 9.11154 20.0266L11.2985 22.2135C11.5914 22.5064 12.0662 22.5064 12.3591 22.2135C12.652 21.9206 12.652 21.4457 12.3591 21.1528L10.2323 19.026L16.4309 14.0216L16.6597 14.2503C16.9526 14.5432 17.4274 14.5432 17.7203 14.2503C18.0132 13.9574 18.0132 13.4826 17.7203 13.1897L17.0881 12.5574C17.0673 12.53 17.0445 12.5038 17.0199 12.4792L15.3937 10.8559C15.8224 10.1749 15.7179 9.27721 15.1403 8.69966C14.557 8.11632 13.665 8.02021 12.9828 8.44927L11.3599 6.8292L11.3583 6.82768L10.6503 6.11967ZM15.3643 12.9549L9.17906 17.9484L5.89192 14.6613L10.8892 8.47982L15.3643 12.9549ZM4.88458 15.7996C4.65145 16.0471 4.45321 16.2728 4.28953 16.4853C4.01168 16.8461 3.86849 17.125 3.81233 17.3576C3.72305 17.7273 3.79849 18.2278 4.71032 19.1397C5.62345 20.0528 6.12308 20.1282 6.49168 20.0393C6.72372 19.9833 7.00229 19.8403 7.36322 19.5621C7.57611 19.3981 7.8023 19.1993 8.05043 18.9655L4.88458 15.7996Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.25 10.5C18.8358 10.5 18.5 10.8358 18.5 11.25C18.5 11.6642 18.8358 12 19.25 12H21.25C21.6642 12 22 11.6642 22 11.25C22 10.8358 21.6642 10.5 21.25 10.5H19.25Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconMegaphone as ReactComponent };
